import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import cx from 'classnames'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addNavigate } from 'shared/src/utils/addNavigate'
import { addAuthContext } from 'shared/src/utils/auth'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { sansSerifFontFamily } from 'utils/styles'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    background: 'none',
    border: 'none',
    fontFamily: sansSerifFontFamily,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '187%',
    color: 'rgba(255, 255, 255, 0.8)',
    cursor: 'pointer',
  },
})

interface Props {
  className?: string
}

export const LogInOut: FC<Props> = flowMax(
  addDisplayName('LogInOut'),
  addAuthContext,
  addTranslationHelpers,
  addProps(({ isAuthenticated, t }) => ({
    text: isAuthenticated ? t('menu.auth.logOut') : t('menu.auth.logIn'),
  })),
  addNavigate,
  addHandlers({
    onClick:
      ({ isAuthenticated, logOut, navigateToLogin, navigate }) =>
      () => {
        if (isAuthenticated) {
          logOut()
          navigate('/')
        } else {
          navigateToLogin({})
        }
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ text, onClick, classes, className }) => (
    <div className={cx(classes.container, className)}>
      <button onClick={onClick} className={classes.button}>
        {text}
      </button>
    </div>
  )
)
